/*
 * Cudeman · buscador instantaneo (sustituye al buscador predictivo del tema).
 * - Indice: /collections/all?view=kf-buscar&sort_by=best-selling (templates/collection.kf-buscar.liquid), en cache 30 min.
 * - Busqueda en el navegador: sin esperas, tolera erratas, sinonimos ES/EN, referencias (206, 148-M, MT5 = MT-5 = MT 5).
 * - Ventana de resultados (cabecera) y pagina /search con el mismo motor. Si algo falla, queda el buscador original.
 * Config y textos: snippets/kf-buscar.liquid (#kfs-config).
 */
(function () {
  'use strict';
  if (window.kfBuscar) return;
  var cfgEl = document.getElementById('kfs-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var S = C.s;
  var BASE = String(C.root || '/').replace(/\/$/, '');
  var SEARCH_URL = C.search || '/search';

  /* ---------------- texto ---------------- */
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss');
  }
  // une codigos de modelo: "mt-5" / "mt 5" -> "mt5", "g-10" -> "g10", "jjsk 2" -> "jjsk2"
  function joinCodes(s) { return s.replace(/\b([a-z]{1,4})[\s\-.\/]+(?=\d)/g, '$1'); }
  function toks(s) { return s.split(/[^a-z0-9]+/).filter(Boolean); }
  function stem(t) { return t.length > 4 ? t.replace(/(es|s)$/, '') : t; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function uniq(a) { var o = [], seen = {}; for (var i = 0; i < a.length; i++) if (!seen[a[i]]) { seen[a[i]] = 1; o.push(a[i]); } return o; }

  // distancia de edicion (con transposiciones), corta a partir de 3
  function dl(a, b) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 2) return 3;
    var d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 0; j <= lb; j++) d[0][j] = j;
    for (i = 1; i <= la; i++) {
      var rowMin = 9;
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > 2) return 3;
    }
    return d[la][lb];
  }

  var STOP = { de: 1, del: 1, la: 1, el: 1, los: 1, las: 1, para: 1, con: 1, y: 1, en: 1, un: 1, una: 1, the: 1, for: 1, with: 1, and: 1, of: 1, a: 1, cudeman: 1 };
  var FUNDA = { funda: 1, fundas: 1, sheath: 1, sheaths: 1, vaina: 1, vainas: 1 };
  // sinonimos de una palabra (ES <-> EN y otros idiomas frecuentes)
  var SYN = {};
  [
    ['navaja', 'pocket', 'folding', 'plegable', 'navalha', 'taschenmesser'],
    ['cuchillo', 'knife', 'knives', 'kes', 'kesek', 'messer', 'couteau', 'coltello', 'faca'],
    ['funda', 'sheath', 'sheaths', 'vaina', 'holster'],
    ['hacha', 'axe', 'axes', 'hatchet', 'tomahawk'],
    ['afilador', 'sharpener', 'afiladora', 'sharpening'],
    ['jamonero', 'jamon', 'ham'],
    ['caza', 'hunting', 'hunt', 'hunter', 'cazador'],
    ['supervivencia', 'survival'],
    ['tactico', 'tactical'],
    ['cocina', 'kitchen', 'chef'],
    ['regalo', 'gift'],
    ['ciervo', 'asta', 'roseta', 'deer', 'antler', 'stag'],
    ['olivo', 'olive'],
    ['nogal', 'walnut'],
    ['cuero', 'leather'],
    ['verde', 'green'], ['negro', 'black', 'negra'], ['naranja', 'orange'], ['rojo', 'red', 'roja'], ['azul', 'blue'], ['marron', 'brown'], ['arena', 'sand', 'coyote'],
    ['mini', 'pequena', 'pequeno', 'small'],
    ['daga', 'dagger', 'punal'],
    ['desollador', 'skinner', 'skinning'],
    ['mango', 'handle'], ['acero', 'steel'], ['hoja', 'blade'],
    ['bushcraft', 'bushcrafter'],
    ['lanzador', 'lanzamiento', 'throwing'],
    ['buceo', 'diving', 'diver'],
    ['pesca', 'fishing'],
    ['coleccion', 'collection', 'collector']
  ].forEach(function (g) { g.forEach(function (w) { SYN[w] = g.filter(function (x) { return x !== w; }); }); });
  // palabras que piden un tipo de producto: se suben los productos de ese tipo
  var KIND = {};
  [['navaja', ['navaja', 'navajas', 'pocket', 'folding', 'plegable', 'plegables', 'navalha', 'taschenmesser']],
   ['cuchillo', ['cuchillo', 'cuchillos', 'kes', 'kesek', 'messer', 'couteau', 'coltello', 'faca']],
   ['hacha', ['hacha', 'hachas', 'axe', 'axes', 'hatchet', 'tomahawk']],
   ['funda', ['funda', 'fundas', 'sheath', 'sheaths', 'vaina', 'vainas']]
  ].forEach(function (g) { g[1].forEach(function (w) { (KIND[w] = KIND[w] || []).push(g[0]); }); });
  ['knife', 'knives'].forEach(function (w) { KIND[w] = ['cuchillo', 'navaja']; });
  // sinonimos de frases (se prueba la consulta con la frase cambiada)
  var PHRASES = [
    ['green beret', 'boina verde'], ['pocket knife', 'navaja'], ['folding knife', 'navaja'], ['hunting knife', 'cuchillo caza'],
    ['ham knife', 'jamonero'], ['survival knife', 'cuchillo supervivencia'], ['deer antler', 'ciervo'], ['olive wood', 'olivo'],
    ['navaja de bolsillo', 'navaja'], ['cuchillo de caza', 'cuchillo caza']
  ];

  /* ---------------- indice ---------------- */
  var IDX = null, CATS = [], loading = null;
  var KEY = 'kfs:' + (C.v || '1') + ':' + BASE + ':' + (C.cur || '');
  var TTL = 30 * 60 * 1000;

  function prepare(data) {
    var items = data.items || [];
    var N = items.length || 1;
    items.forEach(function (p, i) {
      var nt = joinCodes(norm(p.t));
      p._nt = nt;
      p._tt = nt.replace(/^cudeman\s+/, '');
      var skus = String(p.s || '').split(/\s+/).filter(Boolean);
      var skuT = [], comp = [];
      skus.forEach(function (k) { var n = norm(k); var c = n.replace(/[^a-z0-9]/g, ''); comp.push(c); skuT = skuT.concat(toks(n)); skuT.push(c); });
      p._sk = uniq(comp);
      p._f = [
        [uniq(toks(nt)), 10],
        [uniq(skuT), 9],
        [uniq(toks(norm(p.y))), 5],
        [uniq(toks(joinCodes(norm(p.m)))), 4],
        [uniq(toks(joinCodes(norm(p.vt)))), 3],
        [uniq(toks(norm(p.col))), 3],
        [uniq(toks(norm(p.g))), 2]
      ];
      p._fk = p._f.slice(2); // para palabras de tipo (navaja, knife...): tipo, ficha, categorias y etiquetas, no el titulo
      var ny = norm(p.y);
      p._funda = /funda|sheath/.test(ny) || /^f-?\d/.test(norm(p.t)) || /^funda\b/.test(nt);
      p._pop = 1 - i / N;
      p._kind = ny.indexOf('navaja') > -1 ? 'navaja' : ny.indexOf('cuchillo') > -1 && ny.indexOf('set') < 0 ? 'cuchillo' : ny.indexOf('hacha') > -1 ? 'hacha' : p._funda ? 'funda' : ny.indexOf('set') > -1 ? 'set' : 'otro';
    });
    CATS = (data.cats || []).filter(function (c) { return c.t && c.u; });
    CATS.forEach(function (c) { c._f = [[uniq(toks(norm(c.t))), 10], [uniq(toks(norm(c.p))), 3]]; });
    IDX = items;
  }

  function readCache() {
    try { var o = JSON.parse(localStorage.getItem(KEY) || 'null'); if (o && o.d && o.d.items) return o; } catch (e) {}
    return null;
  }
  function writeCache(d) { try { localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), d: d })); } catch (e) {} }

  function fetchPage(n) {
    return fetch(BASE + '/collections/all?view=kf-buscar&sort_by=best-selling&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); });
  }
  function fetchAll() {
    return fetchPage(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= (first.pages || 1); i++) rest.push(fetchPage(i));
      return Promise.all(rest).then(function (pages) {
        var d = { cats: first.cats || [], items: first.items || [] };
        pages.forEach(function (p) { d.items = d.items.concat(p.items || []); });
        return d;
      });
    });
  }
  function load() {
    if (IDX) return Promise.resolve(IDX);
    if (loading) return loading;
    var cached = readCache();
    if (cached) {
      prepare(cached.d);
      if (Date.now() - cached.ts > TTL) fetchAll().then(function (d) { writeCache(d); prepare(d); rerender(); }).catch(function () {});
      loading = Promise.resolve(IDX);
      return loading;
    }
    loading = fetchAll().then(function (d) { writeCache(d); prepare(d); return IDX; });
    loading.catch(function () { loading = null; });
    return loading;
  }

  /* ---------------- motor ---------------- */
  function match(q, t) {
    if (q === t) return 1;
    if (/^\d+$/.test(q)) {
      if (t.indexOf(q) === 0) { var lead = (t.match(/^\d+/) || [''])[0]; return lead === q ? 0.95 : 0.5; }
      return 0;
    }
    if (q.length > 3 && stem(q) === stem(t)) return 0.95;
    if (q.length >= 2 && t.indexOf(q) === 0) return 0.7 + 0.25 * (q.length / t.length);
    if (q.length >= 4 && t.indexOf(q) > 0) return 0.55;
    if (q.length >= 4 && !/\d/.test(q)) {
      var k = q.length >= 7 ? 2 : 1;
      if (Math.abs(t.length - q.length) <= k && dl(q, t) <= k) return 0.6;
      if (t.length > q.length && q.length >= 5 && dl(q, t.slice(0, q.length)) <= 1) return 0.5;
    }
    return 0;
  }
  function tokenScore(qt, fields) {
    var alts = [[qt, 1]];
    var syn = SYN[qt] || SYN[stem(qt)];
    if (syn) syn.forEach(function (s) { alts.push([s, 0.85]); });
    var best = 0;
    for (var a = 0; a < alts.length; a++) {
      for (var f = 0; f < fields.length; f++) {
        var w = fields[f][1] * alts[a][1];
        if (w <= best) continue;
        var list = fields[f][0];
        for (var i = 0; i < list.length; i++) {
          var m = match(alts[a][0], list[i]);
          if (m && m * w > best) { best = m * w; if (m === 1) break; }
        }
      }
    }
    return best;
  }
  function variants(q) {
    var base = norm(q).replace(/\s+/g, ' ').trim();
    var out = [joinCodes(base)];
    if (out[0] !== base) out.push(base);
    PHRASES.forEach(function (p) {
      for (var i = 0; i < 2; i++) {
        var a = p[i], b = p[1 - i];
        out.slice().forEach(function (v) { if (v.indexOf(a) > -1) out.push(v.replace(a, b)); });
      }
    });
    return uniq(out);
  }
  function qTokens(v) {
    var t = toks(v), f = t.filter(function (x) { return !STOP[x]; });
    return f.length ? uniq(f) : uniq(t);
  }

  // devuelve { list: [{p, s}], relaxed: bool, tokens: [] }
  function search(q) {
    if (!IDX) return { list: [], relaxed: false, tokens: [] };
    var vs = variants(q), best = {}, relaxed = {}, allTok = [];
    vs.forEach(function (v) {
      var qt = qTokens(v);
      if (!qt.length) return;
      allTok = allTok.concat(qt);
      var tq = qt.join(' '), cq = tq.replace(/[^a-z0-9]/g, '');
      var fundaIntent = qt.some(function (x) { return FUNDA[x]; }) || /^f\d/.test(cq);
      var kinds = {};
      qt.forEach(function (x) { (KIND[x] || []).forEach(function (k) { kinds[k] = 1; }); });
      // "navajas", "knives"...: solo pide un tipo -> manda lo mas vendido, no el titulo
      var onlyKind = qt.every(function (x) { return KIND[x]; });
      for (var i = 0; i < IDX.length; i++) {
        var p = IDX[i], sum = 0, hit = 0;
        for (var j = 0; j < qt.length; j++) { var s = tokenScore(qt[j], KIND[qt[j]] ? p._fk : p._f); if (s > 0) { hit++; sum += s; } }
        if (!hit) continue;
        if (onlyKind) sum = (kinds[p._kind] ? 10 : sum * 0.5) + 12 * p._pop;
        else {
          if (p._nt.indexOf(tq) > -1) sum += 8;
          if (p._tt.indexOf(tq) === 0) sum += 6;
        }
        if (cq.length >= 3 && p._sk.indexOf(cq) > -1) sum += 40;
        else if (cq.length >= 3 && /\d/.test(cq) && p._sk.some(function (x) { return x.indexOf(cq) === 0; })) sum += 10;
        sum += 3 * p._pop;
        if (kinds[p._kind]) sum += 8;
        if (!p.a) sum *= 0.7;
        if (p._funda && !fundaIntent) sum *= 0.3;
        if (hit === qt.length) { if (!best[p.id] || best[p.id].s < sum) best[p.id] = { p: p, s: sum }; }
        else if (hit >= Math.ceil(qt.length / 2)) { var r = sum * hit / qt.length; if (!relaxed[p.id] || relaxed[p.id].s < r) relaxed[p.id] = { p: p, s: r }; }
      }
    });
    var list = Object.keys(best).map(function (k) { return best[k]; }), isRelaxed = false;
    if (!list.length) { list = Object.keys(relaxed).map(function (k) { return relaxed[k]; }); isRelaxed = list.length > 0; }
    list.sort(function (a, b) { return b.s - a.s || (b.p.a - a.p.a) || (b.p._pop - a.p._pop); });
    if (list.length) {
      var cut = Math.max(2.5, list[0].s * 0.22);
      list = list.filter(function (x) { return x.s >= cut; });
    }
    return { list: list, relaxed: isRelaxed, tokens: uniq(allTok) };
  }

  // si el indice encuentra poco, se completa con el buscador de Shopify (descripciones, etiquetas)
  var FB = {}, fbPending = {};
  function withFallback(q, res, done) {
    var key = norm(q).trim();
    if (res.list.length >= 4 || key.length < 3) return res;
    if (FB[key]) {
      var have = {}; res.list.forEach(function (r) { have[r.p.id] = 1; });
      var extra = FB[key].filter(function (p) { return !have[p.id]; }).map(function (p) { return { p: p, s: 0, fb: true }; });
      if (!extra.length) return res;
      return { list: res.list.concat(extra), relaxed: res.list.length ? res.relaxed : false, tokens: res.tokens, fb: true };
    }
    if (!fbPending[key]) {
      fbPending[key] = 1;
      fetch(BASE + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag,body')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ids = (((j || {}).resources || {}).results || {}).products || [];
          var byId = {}; IDX.forEach(function (p) { byId[p.id] = p; });
          FB[key] = ids.map(function (x) { return byId[x.id]; }).filter(Boolean);
          if (FB[key].length && done) done();
        }).catch(function () { FB[key] = []; });
    }
    return res;
  }

  function searchCats(q, results) {
    if (!CATS.length) return [];
    var out = [], seen = {};
    if (q) {
      var qt = qTokens(joinCodes(norm(q)));
      CATS.forEach(function (c) {
        var sum = 0, hit = 0;
        qt.forEach(function (t) { var s = tokenScore(t, c._f); if (s) { hit++; sum += s; } });
        if (hit === qt.length && qt.length) out.push({ c: c, s: sum });
      });
      out.sort(function (a, b) { return b.s - a.s; });
      out = out.map(function (x) { seen[x.c.u] = 1; return x.c; });
    }
    if (results && results.length) {
      var count = {};
      results.slice(0, 24).forEach(function (r) { (r.p.ch || []).forEach(function (h) { count[h] = (count[h] || 0) + 1; }); });
      CATS.filter(function (c) { return c.h && count[c.h] && !seen[c.u]; })
        .sort(function (a, b) { return count[b.h] - count[a.h] || (a.p ? 1 : 0) - (b.p ? 1 : 0); })
        .forEach(function (c) { out.push(c); seen[c.u] = 1; });
    }
    return out.slice(0, 6);
  }

  function popularProducts(n) {
    if (!IDX) return [];
    return IDX.filter(function (p) { return p.a && !p._funda && p.i; }).slice(0, n).map(function (p) { return { p: p, s: 0 }; });
  }

  function helpFor(q) {
    var qt = qTokens(norm(q));
    return (C.help || []).filter(function (h) {
      return qt.some(function (t) { return t.length >= 3 && h.k.some(function (k) { return k.indexOf(t) === 0 || t.indexOf(k) === 0; }); });
    });
  }

  /* ---------------- pintar ---------------- */
  var ICON_ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_CART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 10.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="19" r="1.5" fill="currentColor"/><circle cx="17" cy="19" r="1.5" fill="currentColor"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function hl(title, tokens) {
    var qs = tokens.filter(function (t) { return t.length >= 2; });
    if (!qs.length) return esc(title);
    return String(title).split(/(\s+)/).map(function (w) {
      if (!w.trim()) return w;
      var nw = joinCodes(norm(w)).replace(/[^a-z0-9]/g, '');
      var on = nw && qs.some(function (q) { return nw.indexOf(q) === 0 || (q.length >= 3 && nw.indexOf(q) > -1) || (q.length > 3 && stem(q) === stem(nw)); });
      return on ? '<mark>' + esc(w) + '</mark>' : esc(w);
    }).join('');
  }
  function num(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var s = (Math.round(n * 10) / 10).toString();
    return C.en ? s : s.replace('.', ',');
  }
  function typeLabel(p) { return (S.types && S.types[p._kind]) || ''; }

  function card(r, i, tokens, origin) {
    var p = r.p, meta = [];
    if (p.sku) meta.push('<span>REF ' + esc(p.sku) + '</span>');
    if (p.bl) meta.push('<span>' + esc(S.blade) + ' ' + num(p.bl) + ' cm</span>');
    if (p.rc > 0 && p.r) meta.push('<span class="kfs-c__r"><b aria-hidden="true">★</b> ' + num(p.r) + ' (' + p.rc + ')</span>');
    var badges = '';
    if (!p.a) badges += '<span class="kfs-c__b kfs-c__b--out">' + esc(S.soldout) + '</span>';
    else if (p.c > p.p) badges += '<span class="kfs-c__b kfs-c__b--sale">-' + Math.round((1 - p.p / p.c) * 100) + '%</span>';
    if (p.fi && p.a) badges += '<span class="kfs-c__b">' + esc(S.sheath) + '</span>';
    var price = (p.pv ? '<small>' + esc(S.from) + '</small> ' : '') + esc(p.pf) + (p.cf ? ' <s>' + esc(p.cf) + '</s>' : '');
    var add = p.qa && p.a
      ? '<button type="button" class="kfs-c__add" data-kfs-add="' + p.qa + '" aria-label="' + esc(S.add + ': ' + p.t) + '">' + ICON_CART + '</button>'
      : '<span class="kfs-c__go" aria-hidden="true">' + ICON_ARROW + '</span>';
    return '<li class="kfs-c' + (p.a ? '' : ' is-out') + '" role="option" id="kfs-' + origin + '-o' + i + '" aria-selected="false">' +
      '<a class="kfs-c__a" href="' + esc(p.u) + '" data-kfs-nav data-kfs-pos="' + (i + 1) + '" data-kfs-p="' + esc(p.t) + '">' +
      '<span class="kfs-c__img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" decoding="async" width="360" height="360">' : '') + (badges ? '<span class="kfs-c__bs">' + badges + '</span>' : '') + '</span>' +
      '<span class="kfs-c__body">' +
      (typeLabel(p) ? '<span class="kfs-c__type">' + esc(typeLabel(p)) + '</span>' : '') +
      '<span class="kfs-c__t">' + hl(p.t, tokens) + '</span>' +
      (meta.length ? '<span class="kfs-c__m">' + meta.join('') + '</span>' : '') +
      '<span class="kfs-c__p">' + price + '</span>' +
      '</span></a>' + add + '</li>';
  }

  function catItem(c, tokens) {
    var sub = [];
    if (c.p) sub.push(esc(c.p));
    if (c.n) sub.push(c.n + ' ' + esc(c.n === 1 ? S.product : S.productsLc));
    return '<li><a class="kfs-cat" href="' + esc(c.u) + '" data-kfs-nav data-kfs-cat="' + esc(c.t) + '">' +
      '<span class="kfs-cat__img">' + (c.i ? '<img src="' + esc(c.i) + '" alt="" loading="lazy" width="160" height="160">' : '') + '</span>' +
      '<span class="kfs-cat__t">' + hl(c.t, tokens) + (sub.length ? '<small>' + sub.join(' · ') + '</small>' : '') + '</span></a></li>';
  }
  function chips(list) {
    return '<div class="kfs-chips">' + list.map(function (t) { return '<button type="button" class="kfs-chip" data-kfs-nav data-kfs-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>';
  }
  function helpList(list) {
    return '<ul class="kfs-help">' + list.map(function (h) { return '<li><a href="' + esc(h.u) + '" data-kfs-nav data-kfs-help="' + esc(h.t) + '">' + esc(h.t) + ICON_ARROW + '</a></li>'; }).join('') + '</ul>';
  }
  function allUrl(q) { return SEARCH_URL + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product'; }

  /* ---------------- ventana (cabecera) ---------------- */
  var root, input, body, foot, opener = null, current = '', active = -1, lastRes = null, pushed = false;

  function build() {
    root = document.getElementById('kfs');
    if (!root) return false;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    input = root.querySelector('.kfs__input');
    body = root.querySelector('.kfs__body');
    foot = root.querySelector('.kfs__foot');
    var clear = root.querySelector('.kfs__clear');
    var t;
    input.addEventListener('input', function () {
      clear.hidden = !input.value;
      clearTimeout(t);
      if (IDX) render(input.value); else t = setTimeout(function () { render(input.value); }, 60);
      track(input.value, 'ventana');
    });
    clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; render(''); input.focus(); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kfs-close]')) { e.preventDefault(); close(); return; }
      var add = e.target.closest('[data-kfs-add]');
      if (add) { e.preventDefault(); quickAdd(add); return; }
      var chip = e.target.closest('[data-kfs-q]');
      if (chip) { e.preventDefault(); input.value = chip.getAttribute('data-kfs-q'); clear.hidden = false; render(input.value); input.focus(); trackClick('popular', chip.getAttribute('data-kfs-q'), 0, ''); return; }
      var a = e.target.closest('a[href]');
      if (a) {
        if (a.hasAttribute('data-kfs-p')) trackClick('producto', a.getAttribute('data-kfs-p'), +a.getAttribute('data-kfs-pos'), a.getAttribute('href'));
        else if (a.hasAttribute('data-kfs-cat')) trackClick('categoria', a.getAttribute('data-kfs-cat'), 0, a.getAttribute('href'));
        else if (a.hasAttribute('data-kfs-help')) trackClick('ayuda', a.getAttribute('data-kfs-help'), 0, a.getAttribute('href'));
        else if (a.hasAttribute('data-kfs-all')) trackClick('ver_todos', '', 0, a.getAttribute('href'));
        flush();
      }
    });
    root.addEventListener('keydown', onKey);
    root.querySelector('.kfs__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var nav = navItems();
      if (active > -1 && nav[active]) { nav[active].click(); return; }
      var q = input.value.trim();
      if (!q) return;
      trackClick('enter', '', 0, ''); flush();
      window.location.href = allUrl(q);
    });
    window.addEventListener('popstate', function () { if (isOpen()) close(true); });
    return true;
  }
  function isOpen() { return root && !root.hidden; }

  function open(q, from) {
    if (!root && !build()) return false;
    opener = from || document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('kfs-open');
    if (typeof q === 'string') { input.value = q; root.querySelector('.kfs__clear').hidden = !q; }
    input.focus({ preventScroll: true });
    try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
    if (!pushed && window.history && history.pushState) { try { history.pushState({ kfs: 1 }, ''); pushed = true; } catch (e) {} }
    render(input.value);
    load().then(function () { if (isOpen()) render(input.value); }).catch(function () { if (isOpen()) failed(); });
    document.dispatchEvent(new CustomEvent('theme:search:open', { bubbles: true }));
    return true;
  }
  function close(fromPop) {
    if (!isOpen()) return;
    flush();
    root.hidden = true;
    document.documentElement.classList.remove('kfs-open');
    if (pushed && !fromPop) { pushed = false; try { history.back(); } catch (e) {} } else pushed = false;
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  function failed() {
    // sin indice (sin conexion o error): se usa la pagina de resultados de siempre
    body.innerHTML = '<div class="kfs-empty"><p>' + esc(S.offline) + '</p></div>';
    foot.innerHTML = '';
  }

  function skeleton() {
    var s = '';
    for (var i = 0; i < 8; i++) s += '<li class="kfs-c kfs-c--sk"><span class="kfs-c__img"></span><span class="kfs-c__body"><span></span><span></span><span></span></span></li>';
    return '<div class="kfs-grid"><aside class="kfs-side"></aside><section class="kfs-main"><ul class="kfs-cards">' + s + '</ul></section></div>';
  }

  function rerender() { if (isOpen()) render(input.value); if (pageEl) renderPage(); }

  function render(qRaw) {
    var q = String(qRaw || '').trim();
    current = q; active = -1; input.removeAttribute('aria-activedescendant');
    if (!IDX) { body.innerHTML = skeleton(); foot.innerHTML = ''; return; }
    var mobile = window.matchMedia('(max-width: 989px)').matches;
    var max = mobile ? 10 : 8;
    var side = '', main = '', res = null, cats, tokens = [];
    if (!q) {
      cats = CATS.filter(function (c) { return !c.p; }).slice(0, 7);
      side += '<section><h3 class="kfs-h">' + esc(S.popular) + '</h3>' + chips(C.popular || []) + '</section>';
      if (cats.length) side += '<section><h3 class="kfs-h">' + esc(S.categories) + '</h3><ul class="kfs-cats">' + cats.map(function (c) { return catItem(c, []); }).join('') + '</ul></section>';
      if (C.helpDefault) side += '<section><h3 class="kfs-h">' + esc(S.help) + '</h3>' + helpList(C.helpDefault) + '</section>';
      main = '<header class="kfs-main__head"><h3 class="kfs-h kfs-h--big">' + esc(S.bestsellers) + '</h3></header>' +
        '<ul class="kfs-cards" role="listbox" id="kfs-list">' + popularProducts(max).map(function (r, i) { return card(r, i, [], 'w'); }).join('') + '</ul>';
      foot.innerHTML = '';
    } else {
      res = withFallback(q, search(q), function () { if (isOpen() && current === q) render(q); }); lastRes = res; tokens = res.tokens;
      cats = searchCats(q, res.list);
      var help = helpFor(q);
      if (res.list.length) {
        if (cats.length) side += '<section><h3 class="kfs-h">' + esc(S.categories) + '</h3><ul class="kfs-cats">' + cats.map(function (c) { return catItem(c, tokens); }).join('') + '</ul></section>';
        if (help.length) side += '<section><h3 class="kfs-h">' + esc(S.help) + '</h3>' + helpList(help) + '</section>';
        main = '<header class="kfs-main__head"><h3 class="kfs-h kfs-h--big">' + esc(S.products) + ' <span class="kfs-count">' + res.list.length + '</span></h3>' +
          '<a class="kfs-all" href="' + esc(allUrl(q)) + '" data-kfs-nav data-kfs-all>' + esc(S.viewAll) + ICON_ARROW + '</a></header>' +
          (res.relaxed ? '<p class="kfs-note">' + esc(S.relaxed.replace('%q', q)) + '</p>' : '') +
          '<ul class="kfs-cards" role="listbox" id="kfs-list">' + res.list.slice(0, max).map(function (r, i) { return card(r, i, tokens, 'w'); }).join('') + '</ul>';
        foot.innerHTML = '<a class="kfs-foot__btn" href="' + esc(allUrl(q)) + '" data-kfs-all>' + esc(S.viewAllN.replace('%n', res.list.length)) + ICON_ARROW + '</a>';
      } else {
        side += '<section><h3 class="kfs-h">' + esc(S.popular) + '</h3>' + chips(C.popular || []) + '</section>';
        if (help.length || C.helpNone) side += '<section><h3 class="kfs-h">' + esc(S.help) + '</h3>' + helpList(help.length ? help : C.helpNone) + '</section>';
        main = '<div class="kfs-none"><p class="kfs-none__t">' + esc(S.none.replace('%q', q)) + '</p><p class="kfs-none__s">' + esc(S.noneTip) + '</p></div>' +
          '<header class="kfs-main__head"><h3 class="kfs-h kfs-h--big">' + esc(S.bestsellers) + '</h3></header>' +
          '<ul class="kfs-cards" role="listbox" id="kfs-list">' + popularProducts(mobile ? 6 : 4).map(function (r, i) { return card(r, i, [], 'w'); }).join('') + '</ul>';
        foot.innerHTML = '';
      }
    }
    body.innerHTML = '<div class="kfs-grid' + (q ? ' kfs-grid--q' : '') + '"><aside class="kfs-side">' + side + '</aside><section class="kfs-main">' + main + '</section></div>';
    body.scrollTop = 0;
    var st = root.querySelector('.kfs__status');
    if (st) st.textContent = q ? (res && res.list.length ? S.statusN.replace('%n', res.list.length) : S.none.replace('%q', q)) : '';
  }

  function navItems() { return Array.prototype.slice.call(root.querySelectorAll('[data-kfs-nav]')); }
  function setActive(i) {
    var nav = navItems();
    nav.forEach(function (el) { el.classList.remove('is-active'); var li = el.closest('[role="option"]'); if (li) li.setAttribute('aria-selected', 'false'); });
    if (i < 0 || !nav.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
    active = Math.max(0, Math.min(i, nav.length - 1));
    var el = nav[active]; el.classList.add('is-active');
    var li = el.closest('[role="option"]');
    if (li) { li.setAttribute('aria-selected', 'true'); input.setAttribute('aria-activedescendant', li.id); } else input.removeAttribute('aria-activedescendant');
    el.scrollIntoView({ block: 'nearest' });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.target !== input) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
  }

  /* ---------------- anadir al carrito ---------------- */
  // el tema abre el carrito lateral al recibir theme:cart:refresh
  function openCart() { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); }
  function quickAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var id = +btn.getAttribute('data-kfs-add');
    fetch(BASE + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.innerHTML = ICON_OK;
        var li = btn.closest('.kfs-c'), a = li && li.querySelector('[data-kfs-p]');
        trackClick('anadir', a ? a.getAttribute('data-kfs-p') : '', a ? +a.getAttribute('data-kfs-pos') : 0, '');
        setTimeout(function () { close(); setTimeout(openCart, 300); }, 450);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        var li = btn.closest('.kfs-c'), a = li && li.querySelector('a');
        if (a) window.location.href = a.href; // si no se puede anadir (p. ej. sin stock), a la ficha
      });
  }

  /* ---------------- medicion (GA4 via pixel personalizado) ---------------- */
  var tTrack, lastSent = '';
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }
  function track(q, origin) {
    clearTimeout(tTrack);
    tTrack = setTimeout(function () { sendSearch(q, origin); }, 1500);
  }
  function sendSearch(q, origin) {
    q = String(q || '').trim();
    if (q.length < 2 || q === lastSent || !IDX) return;
    lastSent = q;
    var r = search(q);
    publish('kf_search', { termino: q.slice(0, 100), resultados: r.list.length, aproximados: r.relaxed ? 1 : 0, origen: origin, idioma: C.en ? 'en' : 'es' });
  }
  function flush() { clearTimeout(tTrack); if (isOpen()) sendSearch(input.value, 'ventana'); }
  function trackClick(el, pieza, pos, dest) {
    publish('kf_search_click', { termino: String(current || '').slice(0, 100), elemento: el, pieza: String(pieza || '').slice(0, 100), posicion: pos || 0, destino: String(dest || '').slice(0, 100), idioma: C.en ? 'en' : 'es' });
  }

  /* ---------------- pagina /search ---------------- */
  var pageEl = null, page = { q: '', type: 'all', stock: false, sort: 'rel', shown: 24 };
  function initPage() {
    if (!document.body.classList.contains('template-search')) return;
    var native = document.querySelector('.search-page');
    var wrap = native && (native.closest('.shopify-section') || native);
    if (!wrap) return;
    var params = new URLSearchParams(location.search);
    page.q = (params.get('q') || '').trim();
    var t = params.get('type');
    if (t && t.indexOf('product') < 0) return; // pestanas de blog/paginas: se deja la pagina original
    pageEl = document.createElement('section');
    pageEl.className = 'kfs-page';
    pageEl.setAttribute('aria-live', 'polite');
    pageEl.innerHTML = '<div class="kfs-page__in"><p class="kfs-page__loading">' + esc(S.loading) + '</p></div>';
    wrap.parentNode.insertBefore(pageEl, wrap);
    load().then(function () {
      wrap.classList.add('kfs-native-off');
      renderPage();
    }).catch(function () { pageEl.remove(); pageEl = null; });
  }
  function filterPage(list) {
    return list.filter(function (r) {
      if (page.stock && !r.p.a) return false;
      if (page.type !== 'all' && r.p._kind !== page.type) return false;
      return true;
    });
  }
  function sortPage(list) {
    var l = list.slice();
    if (page.sort === 'pa') l.sort(function (a, b) { return a.p.p - b.p.p; });
    else if (page.sort === 'pd') l.sort(function (a, b) { return b.p.p - a.p.p; });
    else if (page.sort === 'pop') l.sort(function (a, b) { return (b.p.a - a.p.a) || (b.p._pop - a.p._pop); });
    return l;
  }
  function renderPage(keepInput) {
    if (!pageEl || !IDX) return;
    var q = page.q, res = q ? withFallback(q, search(q), function () { if (page.q === q) renderPage(true); }) : { list: popularProducts(48), relaxed: false, tokens: [] };
    var counts = { all: res.list.length };
    res.list.forEach(function (r) { counts[r.p._kind] = (counts[r.p._kind] || 0) + 1; });
    if (page.type !== 'all' && !counts[page.type]) page.type = 'all';
    var list = sortPage(filterPage(res.list));
    var order = ['cuchillo', 'navaja', 'hacha', 'funda', 'set', 'otro'];
    var typeChips = '<button type="button" class="kfs-chip' + (page.type === 'all' ? ' is-on' : '') + '" data-kfs-type="all" aria-pressed="' + (page.type === 'all') + '">' + esc(S.all) + ' <span>' + counts.all + '</span></button>' +
      order.filter(function (k) { return counts[k]; }).map(function (k) {
        return '<button type="button" class="kfs-chip' + (page.type === k ? ' is-on' : '') + '" data-kfs-type="' + k + '" aria-pressed="' + (page.type === k) + '">' + esc(S.typesPl[k]) + ' <span>' + counts[k] + '</span></button>';
      }).join('');
    var cats = q ? searchCats(q, res.list) : [];
    var help = q ? helpFor(q) : [];
    var html = '';
    if (!keepInput) {
      html += '<form class="kfs-page__form" action="' + esc(SEARCH_URL) + '" method="get" role="search">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '<input class="kfs-page__input" type="search" name="q" value="' + esc(q) + '" placeholder="' + esc(S.placeholder) + '" aria-label="' + esc(S.placeholder) + '" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search">' +
        '<input type="hidden" name="options[prefix]" value="last"><button type="submit" class="kfs-page__go">' + esc(S.search) + '</button></form>';
      html += '<div class="kfs-page__res"></div>';
      pageEl.innerHTML = '<div class="kfs-page__in">' + html + '</div>';
      bindPage();
    }
    var out = '';
    out += '<h1 class="kfs-page__title">' + (q ? esc(S.resultsFor) + ' <em>«' + esc(q) + '»</em>' : esc(S.bestsellers)) + '</h1>';
    if (q && res.list.length) out += '<p class="kfs-page__count">' + esc((list.length === 1 ? S.oneResult : S.nResults).replace('%n', list.length)) + '</p>';
    if (res.relaxed) out += '<p class="kfs-note">' + esc(S.relaxed.replace('%q', q)) + '</p>';
    if (cats.length || help.length) {
      out += '<div class="kfs-page__links">' + cats.map(function (c) { return '<a class="kfs-chip kfs-chip--link" href="' + esc(c.u) + '" data-kfs-cat="' + esc(c.t) + '">' + esc(c.t) + '</a>'; }).join('') +
        help.map(function (h) { return '<a class="kfs-chip kfs-chip--link kfs-chip--help" href="' + esc(h.u) + '" data-kfs-help="' + esc(h.t) + '">' + esc(h.t) + '</a>'; }).join('') + '</div>';
    }
    if (res.list.length) {
      out += '<div class="kfs-page__tools"><div class="kfs-page__types" role="group" aria-label="' + esc(S.type) + '">' + typeChips + '</div>' +
        '<div class="kfs-page__opts"><label class="kfs-page__stock"><input type="checkbox" data-kfs-stock' + (page.stock ? ' checked' : '') + '> ' + esc(S.inStock) + '</label>' +
        '<label class="kfs-page__sort"><span class="visually-hidden">' + esc(S.sortBy) + '</span><select data-kfs-sort>' +
        [['rel', S.sortRel], ['pop', S.sortPop], ['pa', S.sortPa], ['pd', S.sortPd]].map(function (o) { return '<option value="' + o[0] + '"' + (page.sort === o[0] ? ' selected' : '') + '>' + esc(o[1]) + '</option>'; }).join('') +
        '</select></label></div></div>';
      out += '<ul class="kfs-cards kfs-cards--page">' + list.slice(0, page.shown).map(function (r, i) { return card(r, i, res.tokens, 'p'); }).join('') + '</ul>';
      if (list.length > page.shown) out += '<div class="kfs-page__more"><button type="button" class="kfs-btn" data-kfs-more>' + esc(S.more.replace('%n', list.length - page.shown)) + '</button></div>';
      if (!list.length) out += '<p class="kfs-note">' + esc(S.noneFiltered) + '</p>';
    } else if (q) {
      out += '<div class="kfs-none kfs-none--page"><p class="kfs-none__t">' + esc(S.none.replace('%q', q)) + '</p><p class="kfs-none__s">' + esc(S.noneTip) + '</p>' +
        '<h2 class="kfs-h">' + esc(S.popular) + '</h2>' + chips(C.popular || []) +
        '<h2 class="kfs-h">' + esc(S.help) + '</h2>' + helpList(C.helpNone || []) + '</div>' +
        '<h2 class="kfs-h kfs-h--big">' + esc(S.bestsellers) + '</h2><ul class="kfs-cards kfs-cards--page">' + popularProducts(8).map(function (r, i) { return card(r, i, [], 'p'); }).join('') + '</ul>';
    }
    out += '<div class="kfs-page__blog" data-kfs-blog></div>';
    pageEl.querySelector('.kfs-page__res').innerHTML = out;
    if (q) loadBlog(q);
    publishPage(q, res);
  }
  var lastPagePub = '';
  function publishPage(q, res) {
    if (!q || q === lastPagePub) return; lastPagePub = q;
    publish('kf_search', { termino: q.slice(0, 100), resultados: res.list.length, aproximados: res.relaxed ? 1 : 0, origen: 'pagina', idioma: C.en ? 'en' : 'es' });
  }
  function loadBlog(q) {
    var box = pageEl.querySelector('[data-kfs-blog]');
    fetch(BASE + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=article,page&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (page.q !== q || !box) return;
        var res = (j && j.resources && j.resources.results) || {};
        var list = (res.articles || []).concat(res.pages || []);
        if (!list.length) return;
        box.innerHTML = '<h2 class="kfs-h kfs-h--big">' + esc(S.guides) + '</h2><ul class="kfs-help kfs-help--blog">' +
          list.map(function (x) { return '<li><a href="' + esc(x.url) + '" data-kfs-help="' + esc(x.title) + '">' + esc(x.title) + ICON_ARROW + '</a></li>'; }).join('') + '</ul>';
      }).catch(function () {});
  }
  function bindPage() {
    var inp = pageEl.querySelector('.kfs-page__input'), t;
    inp.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        page.q = inp.value.trim(); page.shown = 24; current = page.q;
        try { var u = new URL(location.href); u.searchParams.set('q', page.q); history.replaceState(history.state, '', u); } catch (e) {}
        renderPage(true);
      }, 120);
    });
    pageEl.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-kfs-type]'))) { page.type = b.getAttribute('data-kfs-type'); page.shown = 24; renderPage(true); return; }
      if ((b = e.target.closest('[data-kfs-more]'))) { page.shown += 24; renderPage(true); return; }
      if ((b = e.target.closest('[data-kfs-add]'))) { e.preventDefault(); quickAddPage(b); return; }
      if ((b = e.target.closest('[data-kfs-q]'))) { e.preventDefault(); inp.value = b.getAttribute('data-kfs-q'); page.q = inp.value; page.shown = 24; renderPage(true); return; }
      var a = e.target.closest('a[href]');
      if (a) {
        current = page.q;
        if (a.hasAttribute('data-kfs-p')) trackClick('producto', a.getAttribute('data-kfs-p'), +a.getAttribute('data-kfs-pos'), a.getAttribute('href'));
        else if (a.hasAttribute('data-kfs-cat')) trackClick('categoria', a.getAttribute('data-kfs-cat'), 0, a.getAttribute('href'));
        else if (a.hasAttribute('data-kfs-help')) trackClick('ayuda', a.getAttribute('data-kfs-help'), 0, a.getAttribute('href'));
      }
    });
    pageEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-kfs-stock]')) { page.stock = e.target.checked; page.shown = 24; renderPage(true); }
      if (e.target.matches('[data-kfs-sort]')) { page.sort = e.target.value; renderPage(true); }
    });
  }
  function quickAddPage(btn) {
    // misma logica que en la ventana, sin cerrarla
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    fetch(BASE + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-kfs-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.innerHTML = ICON_OK;
        var a = btn.closest('.kfs-c').querySelector('[data-kfs-p]');
        current = page.q; trackClick('anadir', a.getAttribute('data-kfs-p'), +a.getAttribute('data-kfs-pos'), '');
        openCart();
      })
      .catch(function () { var a = btn.closest('.kfs-c').querySelector('a'); if (a) window.location.href = a.href; });
  }

  /* ---------------- enganche con la cabecera ---------------- */
  function isToggle(el) {
    if (!el || !el.closest) return null;
    if (el.closest('#kfs, .kfs-page')) return null;
    return el.closest('search-popdown [data-popdown-toggle], search-popdown details > summary, a[href$="/search"], a[href*="/search?"]');
  }
  document.addEventListener('click', function (e) {
    var t = isToggle(e.target);
    if (!t || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (t.tagName === 'A' && document.body.classList.contains('template-search')) return;
    var q = '';
    if (t.tagName === 'A') { try { q = new URL(t.href, location.href).searchParams.get('q') || ''; } catch (err) {} }
    if (open(q, t)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  // precarga del indice en cuanto el usuario se acerca a la lupa
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (isToggle(e.target)) load().catch(function () {}); }, { passive: true, capture: true });
  });
  // "/" abre el buscador (escritorio)
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || isOpen()) return;
    var tg = e.target, tag = tg && tg.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (tg && tg.isContentEditable)) return;
    if (open('')) e.preventDefault();
  });

  window.kfBuscar = { open: open, close: close, search: function (q) { return load().then(function () { return search(q); }); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
})();
